<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const props = defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  activeSort: { type: String, default: 'due_date_asc' },
});

const emit = defineEmits(['search', 'update:sort', 'add']);

const sortOptions = [
  { value: 'due_date_asc', label: 'Due Date (Earliest)' },
  { value: 'due_date_desc', label: 'Due Date (Latest)' },
  { value: 'priority_desc', label: 'Priority (High-Low)' },
  { value: 'priority_asc', label: 'Priority (Low-High)' },
  { value: 'created_at_desc', label: 'Created (Newest)' },
  { value: 'created_at_asc', label: 'Created (Oldest)' },
];
</script>

<template>
  <header class="sticky top-0 z-10">
    <div
      class="flex items-start sm:items-center justify-between w-full py-6 px-6 gap-2 mx-auto max-w-[60rem]"
    >
      <span class="text-xl font-medium truncate text-n-slate-12">
        {{ headerTitle }}
      </span>
      <div class="flex items-center flex-col sm:flex-row flex-shrink-0 gap-4">
        <div v-if="showSearch" class="flex items-center gap-2 w-full">
          <Input
            :model-value="searchValue"
            type="search"
            :placeholder="$t('TASKS.SEARCH_PLACEHOLDER')"
            :custom-input-class="[
              'h-8 [&:not(.focus)]:!border-transparent bg-n-alpha-2 dark:bg-n-solid-1 ltr:!pl-8 !py-1 rtl:!pr-8',
            ]"
            class="w-full"
            @input="emit('search', $event.target.value)"
          >
            <template #prefix>
              <Icon
                icon="i-lucide-search"
                class="absolute -translate-y-1/2 text-n-slate-11 size-4 top-1/2 ltr:left-2 rtl:right-2"
              />
            </template>
          </Input>
          <!-- Sort dropdown -->
          <ComboBox
            :model-value="activeSort"
            :options="sortOptions"
            class="w-44"
            @update:model-value="emit('update:sort', $event)"
          />
        </div>
        <div class="flex items-center flex-shrink-0 gap-4">
          <Button
            :label="$t('TASKS.ADD_TASK')"
            icon="i-lucide-plus"
            size="sm"
            @click="emit('add')"
          />
        </div>
      </div>
    </div>
  </header>
</template>
